import { createAction, props } from '@ngrx/store';
import { ContentDto } from '@api/rest';

export const loadContents = createAction(
  '[Content/API] Load Contents'
);

export const loadContentsSuccess = createAction(
  '[Content/API] Load Contents Success',
  props<{ contents: ContentDto[] }>()
);

export const loadContentsFailure = createAction(
  '[Content/API] Load Contents Failure',
  props<{ error: any }>()
);

export const getContent = createAction(
  '[Content/API] Get Content',
  props<{ id: string }>()
);

export const getContentSuccess = createAction(
  '[Content/API] get Content Success',
  props<{ content: ContentDto }>()
);

export const getContentFailure = createAction(
  '[Content/API] Get Content Failure',
  props<{ error: any }>()
);

export const setSelectedContent = createAction(
  '[Content/API] Set Selected Content',
  props<{ id: string }>()
);
